import React, {Component} from "react";
import PlaceholderWrapper from "@mnjsplatform/components/lib/common/PlaceholderWrapper";
import PropTypes from "prop-types";
import i18next from "i18next";
import parse from "html-react-parser";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";

class Instruction extends Component {
    constructor(state, props) {
        super(state, props);
    }
    componentDidMount() {
        this.token = AuthProvider.getToken();
    }
    renderForm = (text) => {
        if (!text)
            return null;
        return <div /*style={{whiteSpace: "pre-wrap"}}*/>{parse(text, {
            replace: (domNode) => {
                if (domNode.name === "a" && domNode.attribs && domNode.attribs.fileid) {
                    const fileID = domNode.attribs.fileid;
                    delete domNode.attribs.fileid;
                    const text = domNode.children && domNode.children.length > 0 ? domNode.children[0].data : "";
                    return <a href="" onClick={(event) => this.getFile(fileID, event)} {...domNode.attribs}>{text}</a>
                } else if (domNode.name === "img" && domNode.attribs && domNode.attribs.fileid) {
                    const fileID = domNode.attribs.fileid;
                    delete domNode.attribs.fileid;
                    return <img src={this.getImageUrl(fileID)} alt={i18next.t("Image")} {...domNode.attribs}/>
                }
                return domNode;
            }
        })}</div>;
    }
    getImageUrl = (fileID) => {
        return pathJoin(window.config.apiRoot, "Instructions", "GetImage") + "?" + $.param({
            b_token: this.token,
            workSiteId: this.props.WorkSiteId,
            commandItemId: this.props.CommandItemId,
            placeholderId: this.props.PlaceholderId,
            fileId: fileID
        });
    }
    /*
        WorkSiteId – идентификатор РМ
        CommandItemId – идентификатор команды в РМ
        PlaceholderId – идентификатор фрейма в команде
        FileId – идентификатор файла
    */
    getFile = async (fileID, event) => {
        event.preventDefault();
        //const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "Instructions", "GetInstruction") + "?" + $.param({
            b_token: this.token,
            workSiteId: this.props.WorkSiteId,
            commandItemId: this.props.CommandItemId,
            placeholderId: this.props.PlaceholderId,
            fileId: fileID
        });
        window.open(downloadPath, '_blank');
    }

    render() {
        if (!this.props.HelpText)
            return null;
        return <PlaceholderWrapper placeholderId={this.props.instructionId || `INSTRUCTION_${this.props.PlaceholderId}`}
                                   title={<><i className='fa fa-info-circle text-black-50'/> {this.props.HeaderText}</>}
                                   style={this.props.style}
                                   showHeaderTitle={!!this.props.HeaderText}
                                   showSplitterLine={!!this.props.HeaderText}
                                   collapsed={this.props.IsExpand !== 1}
        >
            {this.renderForm(this.props.HelpText)}
        </PlaceholderWrapper>
    }
}

Instruction.propTypes = {
    PlaceholderId: PropTypes.string.isRequired,
    WorkSiteId: PropTypes.string.isRequired,
    CommandItemId: PropTypes.string,
    style: PropTypes.object,
    instructionId: PropTypes.string,
    HelpText: PropTypes.string,
    HeaderText: PropTypes.string,
    IsExpand: PropTypes.number
};

Instruction.defaultProps = {
    instructionId: "INSTRUCTION"
};

export default Instruction;
